module.exports = __webpack_public_path__ + "ff6e13624ca2ac5c9d3514b2c2f4d085.png";